import { motion } from 'framer-motion';
import { ShieldCheck, Award, HardHat, BadgeCheck, Languages } from 'lucide-react';

const badges = [
  { icon: ShieldCheck, label: 'Licensed & Bonded' },
  { icon: HardHat, label: 'Fully Insured Crews' },
  { icon: Award, label: '4.9★ Google Rating' },
  { icon: BadgeCheck, label: 'EPA Lead-Safe Certified' },
  { icon: Languages, label: 'Bilingual · Se Habla Español', accent: true },
];

export default function TrustBadges() {
  return (
    <section className="relative bg-white border-y border-[#1D4ED8]/20 py-14">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-10">
        {badges.map((b, i) => (
          <motion.div
            key={b.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.05 }}
            className="flex items-center gap-4"
          >
            <div
              className={`w-11 h-11 grid place-items-center border ${
                b.accent
                  ? 'border-[#DC2626] text-[#DC2626]'
                  : 'border-[#1D4ED8]/40 text-[#1D4ED8]'
              }`}
            >
              <b.icon className="w-5 h-5" />
            </div>
            <div className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-[#0A0A0A]/75 leading-tight">
              {b.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
